import { useFrame } from '@react-three/fiber';
import { Suspense, useRef, useState } from 'react';
import { Group } from 'three';

import Tiles, { TilesRef } from '0_canvas/Tiles/Tiles';
import { useThreeStore } from 'state/threeStore';
import useTilesStore from 'state/tilesStore';

import OverAddresScene from '../OverAddresScene/OverAddresScene';
import PerilsScene from '../PerilsScene/PerilsScene';

import useMatrixUpdateHandler from 'hooks/useMatrixUpdateHandler';

const TilesScene = () => {
  const tilesRef = useRef<TilesRef>(null!);
  const tilesSceneRef = useRef<Group>(null);
  const [tilesRendered, setTilesRendered] = useState<boolean>(false);

  useFrame(() => {
    const { place, tileDefinitions } = useTilesStore.getState();

    if (!place || !tileDefinitions.length) {
      tilesRef.current.reset();
      setTilesRendered(false);

      return;
    }

    tilesRef.current.initialize(place, tileDefinitions);

    if (!tilesSceneRef.current) return;
    setTilesRendered(true);

    const {
      tiles: { isRendered },
    } = useThreeStore.getState();

    (tilesSceneRef.current as any).visible =
      isRendered && !!place && tileDefinitions.length;
  });

  useMatrixUpdateHandler(
    () => !!useThreeStore.getState().tiles.isRendered,
    tilesSceneRef.current
  );

  return (
    <group ref={tilesSceneRef} visible={false}>
      <Tiles ref={tilesRef} />

      {/*
        These mount partway through the experience and load their own
        textures, so they suspend on mount. Contain that here, otherwise the
        suspension travels past the Canvas and remounts the whole scene.
      */}
      {tilesRendered && (
        <Suspense fallback={null}>
          <PerilsScene />
          <OverAddresScene />
        </Suspense>
      )}
    </group>
  );
};

export default TilesScene;
